<template>
  <div>
    <div class="w95mg whitebox">
      <h2 class="chart-title">数据列表 <span class="fr upload-btn" @click="isShowUpload = true">上传文件</span><span class="fr mr-1 upload-btn" @click="isShowUploadData = true">上传数据</span></h2>
      
      <div class="pb-5">
        <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
          <tr>
            <th>序号</th>
            <th>名称</th>
            <th>上传时间</th>
            <th>编辑</th>
          </tr>
          <tr v-for="(item, index) in chartList" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.date }}</td>
            <td><span class="curp" @click="routerblank('/chartDetail?id='+ item.id)">查看详情</span></td>
          </tr>
        </table>
      </div>
      <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
        <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" v-bind:max-page="maxPage"
          v-on:pagehandler="pageHandler"></zpagenav>
      </div>
    </div>
    <el-dialog class="" title="上传文件" :visible.sync="isShowUpload" width="650px" top="25vh">
    <el-upload
      class="upload-demo"
      ref="upload"
      :action="''"
      :http-request="customUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :file-list="fileList"
      :auto-upload="false"
      drag>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <!-- <el-button slot="trigger" size="small" type="primary">选取文件</el-button> -->
      <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
    </el-upload>
    <div class="oh">
      <el-button class="fr mt-1" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <!-- <el-button class="fr mr-1" size="small" type="" @click="isShowUpload = false">取消</el-button> -->
    </div>
    
  </el-dialog>
  <el-dialog class="" title="上传数据" :close-on-click-modal="false" :visible.sync="isShowUploadData" width="650px" top="25vh">
    <el-input type="text" placeholder="请输入标题" v-model="title" class="mb-1"></el-input>
    <el-input
      type="textarea"
      :rows="12"
      placeholder="请输入内容"
      v-model="uploadData">
    </el-input>
    <div class="oh">
      <el-button class="fr mt-1" size="small" type="success" @click="submitUploadData">上传到服务器</el-button>
      <!-- <el-button class="fr mr-1" size="small" type="" @click="isShowUpload = false">取消</el-button> -->
    </div>
    
  </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userdata: {},
      page: 1, //显示的是哪一页
      haspage: true, //是否还有下一页
      pageSize: 10, //每一页显示的数据条数
      total: 0, //记录总数
      totalPage: 1,
      maxPage: 10, //最大页数 
      chartList: [],
      kw: '',
      isShowUpload: false,
      isShowUploadData: false,
      uploadData: '',
      title: '',
      fileList: [],
    }
  },
  mounted() {
    this.userdata = this.getuseriformation();
    this.getlist();
  },
  methods: {
    handlePreview(file) {
      console.log(file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    customUpload(options) {
      const formData = new FormData();
      formData.append('file', options.file);
      let ajaxurl = this.$api.common.chart.upload();
      this.$axios.post(ajaxurl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => {
        this.$message.success('文件上传成功');
        options.onSuccess(res.data);
        this.isShowUpload = false;
      })
      .catch(error => {
        this.$message.error('文件上传失败');
        options.onError(error);
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    submitUploadData() {
      var _this = this;
      if(this.title == '') {
        this.$message.error('请输入标题');
        return;
      }else if(this.uploadData == '') {
        this.$message.error('请输入内容');
        return;
      }
      let ajaxurl = this.$api.common.chart.postData();
      // this.$axios.post(ajaxurl,{title: this.title,data: this.uploadData}).then(res => {
      //   this.$message.success('数据上传成功');
      //   this.isShowUploadData = false;
      //   this.getlist();
      // })

      $.ajax({
					type: "post",
					url: ajaxurl,
					data: {title: this.title,data: this.uploadData},
					success: function(res) {
            console.log(res);
						if (res.success) {
              _this.$message.success('数据上传成功');
              _this.isShowUploadData = false;
              _this.getlist();
						}
					}
				})
    },
    pageHandler: function (page) {
      this.getlist(page);
    },
    getlist(pages) {
      console.log("图表列表",);
      var _this = this;
      var ajaxurl = this.$api.common.chart.list()
      this.bus.$emit('loading', true);  
      this.$axios.get(ajaxurl).then(function (res) {
        console.log("图表列表", ajaxurl, res);
        if (res.data.success) {
          _this.chartList = res.data.list;
          _this.bus.$emit('loading', false);
          _this.totalPage = res.data.totalPage;
          _this.pageSize = res.data.pageSize;
          _this.total = res.data.totalRecord;
          _this.haspage = res.data.list.length == res.data.pageSize;
        }
        else {

        }
      }).catch(function (error) {
        // 请求失败处理 console.log(error);
      });

    },

  }

}
</script>

<style>
.upload-btn {
  color: #fff;
  background-color: #409EFF;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  
}
.el-upload {
  width: 100%;
}

.el-upload-dragger {
  width: 100% !important;
}

.chart-title {
  padding: 20px 40px;
  font-size: 20px;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;
  font-weight: 600;
  line-height: 1;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}
</style>